// extracted by mini-css-extract-plugin
export default {"crossSellCard":"crossSellCard__ODlmO","body":"body__NmUwO","previewContainer":"previewContainer__MjdmZ"};